import styled from "styled-components"

export const Base = styled.div`
  margin: var(--size-5) 0;
  display: flex;
  justify-content: center;
  gap: var(--size-5);

  > svg {
    height: var(--size-10) !important;
    width: var(--size-10) !important;

    &.very-bad {
      --color-fill: var(--color-error);
    }
    &.bad {
      --color-fill: var(--color-accent2);
    }
    &.neutral {
      --color-fill: var(--color-warning-dark);
    }
    &.good {
      --color-fill: var(--color-accent1);
    }
    &.very-good {
      --color-fill: var(--color-success);
    }

    &.active {
      fill: var(--color-fill);
    }
  }

  &:not(.disabled) {
    > svg {
      &:hover {
        cursor: pointer;
        fill: var(--color-fill);
      }
    }
  }
`
